export enum CreditCardType {
	VISA,
	MASTERCARD,
	AMEX,
	DISCOVER
}
